const getDecimalPattern = (allowNegative: boolean) =>
	allowNegative ? /^-?\d*([.,]\d*)?$/ : /^\d*([.,]\d*)?$/;

export const isValidDecimalInput = (
	value: string,
	options?: { allowNegative?: boolean },
) => {
	const allowNegative = options?.allowNegative ?? true;

	return getDecimalPattern(allowNegative).test(value);
};

export const parseDecimalInput = (
	value: string,
	options?: { fallbackValue?: number },
) => {
	const fallbackValue = options?.fallbackValue ?? 0;
	const normalizedValue = value.trim().replace(",", ".");

	if (
		normalizedValue === "" ||
		normalizedValue === "-" ||
		normalizedValue === "." ||
		normalizedValue === "-."
	) {
		return fallbackValue;
	}

	const parsedValue = Number.parseFloat(normalizedValue);

	return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
};
